import React, { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { AiOutlineAlignRight } from "react-icons/ai";
import classes from "./Navbar.module.css";

import clsx from "clsx";
import { mainLogo } from "images";
import { Button } from "components/common";
import { NavLink, useLocation } from "react-router-dom";

const Navbar = () => {
  const [sidebar, setSidebar] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation(); // Hook to get current pathname
  const currentPath = location.pathname; // Extracting the pathname

  const handleScroll = () => {
    if (window.scrollY > 90) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div
      className={clsx(
        classes.wrapper,
        (isScrolled || sidebar) && classes.wrapperBg
      )}
    >
      <header className={clsx(classes.header, "container")}>
        <NavLink
          className={clsx(classes.navItem, classes.logoContainer)}
          to="/"
          onClick={() => setSidebar((prev) => !prev)}
        >
          <img src={mainLogo} alt="#" className={classes.logo} />
        </NavLink>

        <div
          className={clsx(
            classes.navItems,
            sidebar && classes.sidebar,
            "overflow"
          )}
        >
          <IoMdClose
            className={clsx(classes.icon, classes.closeIcon)}
            onClick={() => setSidebar((prev) => !prev)}
          />{" "}
          <Button
            className={classes.button}
            primitive700={currentPath === "/sign-up"}
            to="/login"
          >
            Login
          </Button>
          <Button
            className={classes.button}
            primitive700={currentPath === "/login"}
            to="/sign-up"
          >
            SignUp
          </Button>{" "}
        </div>
        <div className={classes.buttonContainer}>
          {sidebar ? (
            <IoMdClose
              className={classes.icon}
              onClick={() => setSidebar((prev) => !prev)}
            />
          ) : (
            <AiOutlineAlignRight
              className={classes.icon}
              onClick={() => setSidebar((prev) => !prev)}
            />
          )}
        </div>
      </header>
    </div>
  );
};

export default Navbar;
